import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BfmComparativeComponent } from '@celerofinancas/ui-reports';
import { triggerReportsBootstrapWarmup } from '@pages/results/shared/reports-bootstrap-warmup';
import { MainTitleComponent } from '@shared/components/main-title/main-title.component';
import { NavigationBarComponent } from '@shared/components/navigation-bar/navigation-bar.component';
import { BootstrapCoordinator } from '@shared/models/bootstrap-coordinator';

/**
 * Comparative Reports Component
 */
@Component({
  selector: 'caixa-webcomponent-comparative-reports',
  templateUrl: './comparative-reports.component.html',
  styleUrls: ['./comparative-reports.component.scss'],
  standalone: true,
  imports: [
    BfmComparativeComponent,
    MainTitleComponent,
    NavigationBarComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComparativeReportsComponent extends BootstrapCoordinator implements OnInit {
  /**
   * Lifecycle hook that is called once the component is initialized. Triggers
   * the core-registry bootstrap because this page does not fire any HTTP
   * request on mount, which would otherwise leave the cost center filter
   * empty until the user clicks "Analisar".
   */
  public override ngOnInit(): void {
    super.ngOnInit();
    triggerReportsBootstrapWarmup(this.store);
  }
}
